import { cx } from "shared/utils";

const PROPERTY_SHIELD_EXPLAINER =
  "Independent monitoring that finds copies of your listings posted by scammers on other platforms.";

export const PROPERTY_SHIELD_MARK = "/assets/property_shield_mark.png";

interface Props {
  variant?: "default" | "compact";
  description?: string;
  className?: string;
}

/** Alerts come from Property Shield, not Boom, so the source is always named. */
export const PoweredByPropertyShield = ({
  variant = "default",
  description = PROPERTY_SHIELD_EXPLAINER,
  className
}: Props) => {
  if (variant === "compact")
    return (
      <div
        className={cx(
          "flex items-center gap-1.5 text-xs text-content-400",
          className
        )}
      >
        <img
          src={PROPERTY_SHIELD_MARK}
          alt=""
          className="size-3.5 shrink-0 object-contain"
        />
        <span>Powered by Property Shield</span>
      </div>
    );

  return (
    <div className={cx("flex items-center gap-4", className)}>
      <img
        src={PROPERTY_SHIELD_MARK}
        alt="Property Shield"
        className="size-10 shrink-0 object-contain"
      />
      <div className="min-w-0 text-sm">
        <p className="font-bold text-content-1000">
          Powered by Property Shield
        </p>
        <p className="font-medium text-content-400">{description}</p>
      </div>
    </div>
  );
};
